// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"dfa80f3d","684":"2bdd7d55"}[chunkId] + ".chunk.js";
};